import { render, staticRenderFns } from "./Controls.vue?vue&type=template&id=1b80a6bc&scoped=true&"
import script from "./Controls.vue?vue&type=script&lang=js&"
export * from "./Controls.vue?vue&type=script&lang=js&"
import style0 from "./Controls.vue?vue&type=style&index=0&id=1b80a6bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b80a6bc",
  null
  
)

export default component.exports